// Suppresses a dev-only React 19 false-positive warning emitted because next-themes
// renders its anti-FOUC <script> inline. The script runs correctly during SSR; the
// warning only fires on client renders and never appears in production.
//
// See https://github.com/pacocoursey/next-themes/issues/387
//
// Safety: dev-only, idempotent, fails open. Matches the full distinctive sentence so no
// unrelated error can collide. Exceptions / error boundaries / Sentry-style capture are
// untouched — this only filters one specific console.error string.

declare global {
  interface Window {
    __nextThemesScriptWarningSuppressed?: boolean;
  }
}

if (typeof window !== "undefined" && process.env.NODE_ENV === "development" && !window.__nextThemesScriptWarningSuppressed) {
  window.__nextThemesScriptWarningSuppressed = true;
  const original = console.error;
  console.error = (...args: unknown[]) => {
    if (typeof args[0] === "string" && args[0].includes("Encountered a script tag while rendering React component")) {
      return;
    }
    original.apply(console, args);
  };
}

export {};
